import { Injectable } from '@angular/core';
import { keys } from '@y42/util/object-utils';
import { SsoStorage, SsoStorageKey } from '../../models/sso-storage.model';

@Injectable({
  providedIn: 'root',
})
export class SsoBrowserStorageService implements Storage {
  private readonly storageKey = '__y42_sso__';

  get length(): number {
    return keys(this.getSsoAuth() || {}).length;
  }

  clear(): void {
    localStorage.setItem(this.storageKey, JSON.stringify({}));
  }

  getItem(key: SsoStorageKey): string | null {
    return this.getSsoAuth()[key] || null;
  }

  key(index: number): string | null {
    const ssoKeys = keys(this.getSsoAuth());
    return ssoKeys[index] || null;
  }

  removeItem(key: SsoStorageKey): void {
    const { [key]: _, ...ssoAuthWithoutKey } = this.getSsoAuth();
    localStorage.setItem(this.storageKey, JSON.stringify(ssoAuthWithoutKey));
  }

  setItem(key: SsoStorageKey, value: string): void {
    const ssoAuth = this.getSsoAuth();
    ssoAuth[key] = value;
    localStorage.setItem(this.storageKey, JSON.stringify(ssoAuth));
  }

  getSsoAuth(): SsoStorage {
    try {
      const ssoAuth = localStorage.getItem(this.storageKey);
      return ssoAuth ? JSON.parse(ssoAuth) : {};
    } catch (error) {
      console.error(error);
      return {};
    }
  }
}
